import { App } from 'vue';
import axios from 'axios';
import defaultAxios from 'axios';
import VueAxios from 'vue-axios';
import JwtService from '@/core/services/JwtService';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    ApiService.vueInstance.axios.defaults.baseURL = 'https://localhost/';
  }

  public static getVueAxiosInstance() {
    return ApiService.vueInstance;
  }

  /**
   *
   * @param url
   */
  public static setBaseUrl(url): void {
    ApiService.vueInstance.axios.defaults.baseURL = url;
  }

  /**
   * @description set the default HTTP request headers Auth
   */
  public static setHeader(): void {
    ApiService.vueInstance.axios.defaults.headers.common[
        'Authorization'
        ] = `Bearer ${JwtService.getToken()}`;

    // set lang header
    let lang = null;
    if (JwtService.getLanguage()) {
      lang = (JwtService.getLanguage());
    }
    ApiService.vueInstance.axios.defaults.headers.common[
        'Lang'
        ] = lang ? lang : 'ar';

  }

  /**
   * @description set the default HTTP request headers Auth
   */
  public static setHeaderForced(token): void {
    ApiService.vueInstance.axios.defaults.headers.common[
        'Authorization'
        ] = `Bearer ${token}`;
  }

  /**
   * @description set the default HTTP request headers
   */
  public static setHeaderPayload(key: any, value: any): void {
    // axios.defaults.headers.common[key] = value;
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static query(
      resource: string,
      params: AxiosRequestConfig,
  ) {
    return ApiService.vueInstance.axios.get(resource, params);
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param slug: string
   * @returns Promise<AxiosResponse>
   */
  public static get(
      resource: string,
      slug = '' as string,
  ) {
    return ApiService.vueInstance.axios.get(`${resource}/${slug}`);
  }

  /**
   * @description set the POST HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static post(
      resource: string,
      params: AxiosRequestConfig,
      config: any = null,
  ) {
    if (config) {
      return ApiService.vueInstance.axios.post(`${resource}`, params, config);
    }
    return ApiService.vueInstance.axios.post(`${resource}`, params);
  }

  /**
   * @description send the UPDATE HTTP request
   * @param resource: string
   * @param slug: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static update(
      resource: string,
      slug: string,
      params: AxiosRequestConfig,
  ) {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
    // .catch(error => {
    //     if (error.request._isRedirect) {
    //       console.log("REDIRECT ERROR :::: "+error.request._options.path);
    //       this.setBaseUrl(error.request._options.path);
    //       return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params)
    //     }
    //   })
  }

  /**
   * @description Send the PUT HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static put(
      resource: string,
      params: AxiosRequestConfig,
  ) {
    return ApiService.vueInstance.axios.put(`${resource}`, params);
  }

  /**
   * @description Send the DELETE HTTP request
   * @param resource: string
   * @returns Promise<AxiosResponse>
   */
  public static delete(resource: string, payload: AxiosRequestConfig) {
    return ApiService.vueInstance.axios.delete(resource, { data: payload });
  }

  /**
   *
   */
  public static instance() {
    return ApiService.vueInstance;
  }
}

export default ApiService;
